// The help centre's routes (not sitemap screens; docs/v3/FEEDBACK-PLAN.md).
import { extra, page, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  extra("/help", page(() => import("./pages/HelpPage"), "TeamHelpPage"), { allowNoOrg: true }),
  extra("/portal/help", page(() => import("./pages/HelpPage"), "ExpertHelpPage")),
];
